var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrefixEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49967 3.66671L0.833008 9.33336V12.1667H3.66634L9.33301 6.50003M6.49967 3.66671L8.5316 1.63474L8.53288 1.63354C8.81253 1.35383 8.95263 1.21373 9.11413 1.16126C9.25644 1.11503 9.40965 1.11503 9.55195 1.16126C9.71331 1.21369 9.85328 1.35363 10.1326 1.63294L11.3649 2.8653C11.6454 3.14582 11.7858 3.28614 11.8383 3.44787C11.8846 3.59013 11.8845 3.74337 11.8383 3.88564C11.7858 4.04725 11.6457 4.18736 11.3656 4.46747L11.3649 4.46808L9.33301 6.50003M6.49967 3.66671L9.33301 6.50003",
    stroke: "black",
    strokeWidth: 1.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrefixEdit);
export default __webpack_public_path__ + "static/media/prefixEdit.9f166f8c581a6065653665c843bd6ec6.svg";
export { ForwardRef as ReactComponent };